import { Dispatch, FC, SetStateAction, memo, useState } from 'react'

import { createUninitializedContext } from '@crew/utils/context'
import { MeetingMinutesGenerateError } from '@crew/enums/domain'

import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'

import { EventDetailMeetingMinutesToolbar } from './eventDetailMeetingMinutesToolbar/eventDetailMeetingMinutesToolbar'
import { EventDetailMeetingMinutesPanel } from './eventDetailMeetingMinutesPanel/eventDetailMeetingMinutesPanel'

/** Context用の型 */
type EventDetailMeetingMinutesContextType = {
  // 議事録を編集中か
  isEditMinutes: boolean
  // 議事録の編集状態を更新する関数
  setIsEditMinutes: Dispatch<SetStateAction<boolean>>
  // 議事録がAI生成中か
  generatingMinutes: boolean
  // 議事録のAI生成中状態を更新する関数
  setGeneratingMinutes: Dispatch<SetStateAction<boolean>>
  // 議事録生成エラーの種類。エラーがない場合はnull
  generateMeetingMinutesError: MeetingMinutesGenerateError | null
  // 議事録生成エラー状態を更新する関数
  setGenerateMeetingMinutesError: Dispatch<
    SetStateAction<MeetingMinutesGenerateError | null>
  >
  // 文字起こしを編集中か
  isEditTranscribe: boolean
  // 文字起こしの編集状態を更新する関数
  setIsEditTranscribe: Dispatch<SetStateAction<boolean>>
}

/** Context */
const {
  context: eventDetailMeetingMinutesContext,
  useInitializedContext: useEventDetailMeetingMinutesContext,
} = createUninitializedContext<EventDetailMeetingMinutesContextType>()

type EventDetailMeetingMinutesProps = {
  // 録画ファイルが1件でも存在するかどうか
  // 議事録生成ボタンが押下可能かどうかの判定に使用する
  hasRecordingFiles: boolean
}

export { useEventDetailMeetingMinutesContext }

export const EventDetailMeetingMinutes: FC<EventDetailMeetingMinutesProps> =
  memo((props) => {
    // 議事録を編集中か
    const [isEditMinutes, setIsEditMinutes] = useState(false)
    // 議事録生成中かどうか
    const [generatingMinutes, setGeneratingMinutes] = useState(false)
    // 議事録生成エラーの種類。エラーがない場合はnull
    const [generateMeetingMinutesError, setGenerateMeetingMinutesError] =
      useState<MeetingMinutesGenerateError | null>(null)
    // 文字起こしを編集中か
    const [isEditTranscribe, setIsEditTranscribe] = useState(false)

    return (
      <eventDetailMeetingMinutesContext.Provider
        value={{
          isEditMinutes,
          setIsEditMinutes,
          generatingMinutes,
          setGeneratingMinutes,
          generateMeetingMinutesError,
          setGenerateMeetingMinutesError,
          isEditTranscribe,
          setIsEditTranscribe,
        }}
      >
        <CrewErrorBoundary>
          <EventDetailMeetingMinutesToolbar
            hasRecordingFiles={props.hasRecordingFiles}
          />
        </CrewErrorBoundary>

        <CrewErrorBoundary>
          <div className="h-full grow min-h-0 p-2 overflow-y-auto">
            <EventDetailMeetingMinutesPanel />
          </div>
        </CrewErrorBoundary>
      </eventDetailMeetingMinutesContext.Provider>
    )
  })
